<template>
  <footer class="c-front-footer">
    <div class="container">
      <div class="footer__brand">
        <img alt="BCR logo" src="@/assets/images/front_logo.svg">
      </div>
      <nav class="footer__nav">
        <ul>
          <li>
            <img alt="BCR logo" src="@/assets/images/mail.svg">
            <a href="mailto:rosporc@bcr.com.ar">rosporc@bcr.com.ar</a>
          </li>
          <li>
            <img alt="BCR logo" src="@/assets/images/whatsapp.svg">
            <a href="https://api.whatsapp.com/send?phone=+5493416806308&text=Hola!%20Quiero%20realizar%20una%20consulta" target="_blank">
              +54 9 341 680-6308
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
}
</script>
